import { combineReducers } from 'redux';
import schedule from './schedule.reducer';
import home from './home.reducer';
import photovideo from './photovideo.reducer';
import medals from './medals.reducer';
import materials from './materials.reducer';
import calendar from './calendar.reducer';

export default combineReducers({
    schedule,
    medals,
    home,
    photovideo,
    materials,
    calendar
});



// WEBPACK FOOTER //
// ./src/reducers/index.js